"use client";

import ProgressButton from "@/components/ui/Button/ProgressButton";

/**
 * Le bouton « Continuer » de la séquence de fin de leçon Reps (récap, série,
 * quêtes, badge).
 *
 * Il porte la barre de progression intégrée (pattern maison ElevenLabs) : entre
 * le clic et l'arrivée sur le parcours, il y a un vrai temps d'attente (envoi de
 * la progression, puis chargement de la page). Sans barre, l'écran semblait
 * figé et on cliquait une seconde fois.
 *
 * Le remplissage est la LÈVRE du bouton (orange-700), pas une couleur importée :
 * la barre reste dans la palette exacte du bouton.
 *
 * @param {boolean} loading - une action est en cours (attente réseau ou navigation)
 * @param {boolean} wide    - pleine largeur (récap, quêtes, badge) ou compact (série)
 */
export default function RepsContinueButton({
    onClick,
    loading = false,
    wide = true,
    className = "",
    children,
}) {
    // Recopié à l'identique sur le bouton ET sur l'overlay : les deux couches
    // doivent avoir le même box, sinon le libellé se décale au passage de la barre.
    const layout = wide
        ? "w-full py-3.5 text-base font-bold"
        : "px-8 py-3 text-sm font-bold";

    return (
        <ProgressButton
            type="button"
            onClick={onClick}
            // Pendant l'attente, un second clic ne ferait que relancer la même
            // navigation : la barre dit déjà que ça travaille.
            disabled={loading}
            loading={loading}
            fillBg="#c2410c"
            fillText="#ffffff"
            className={`flex items-center justify-center rounded-2xl border-b-4 border-b-orange-700 bg-orange-500 text-white transition-all hover:bg-orange-600 active:translate-y-1 active:border-b-transparent ${layout} ${className}`}
            overlayClassName={`flex items-center justify-center ${layout}`}
        >
            {children}
        </ProgressButton>
    );
}
